// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__10oIJ","noInteraction":"EventWrapper_noInteraction__1KdQ0","pointerPassthrough":"EventWrapper_pointerPassthrough__z7AbD"};